import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { QUERY_KEY } from '@/utils';
import { getBenefitBaseInfo } from '@/services/global';
import { useGlobalLoading } from './use-global-loading';

export const useMemberQuotaBase = () => {
  const { setGlobalLoading } = useGlobalLoading();

  const {
    data: memberQuotaBase,
    refetch: refetchMemberQuotaBase,
    isLoading: isMemberQuotaBaseLoading,
    isFetched: isMemberQuotaBaseFetched,
  } = useQuery({
    queryKey: [QUERY_KEY.MemberQuotaBase],
    queryFn: getBenefitBaseInfo,
    staleTime: Infinity,
  });

  const isLoading = isMemberQuotaBaseLoading;
  const isFetched = isMemberQuotaBaseFetched;

  useEffect(() => {
    if (isLoading) setGlobalLoading(true);
    else setGlobalLoading(false);
  }, [isLoading, setGlobalLoading]);
  return {
    memberQuotaBase: memberQuotaBase?.memberTypeCode === 'PREMIUM_PACKAGE',
    memberQuotaBaseInfo: memberQuotaBase,
    getMemberQuotaBase: () => {
      refetchMemberQuotaBase();
    },
    isFetched,
  };
};
